import { DonorIntakeSituation } from "@nkr/enums/donor-intake-situation";
import { VoucherEducationChoice } from "@nkr/enums/voucher-education-choice";
import { Label } from "react-bootstrap";

interface IProps {
    voucherEducationChoiceId: number,
    donorSituationId: number
}

const PreferredDonationType = (props: IProps) => {
    let vemDesc = props.voucherEducationChoiceId == VoucherEducationChoice.WantsToLearnMore ? 'Wants info on ' : '';

    switch (props.donorSituationId) {
        case DonorIntakeSituation.DirectedDonor: return <Label>Directed Donation</Label>;
        case DonorIntakeSituation.StandardVoucher: return <Label bsStyle='success'>{vemDesc}Standard Voucher Donation</Label>;
        case DonorIntakeSituation.NonDirectedDonor: return <Label bsStyle='info'>Non-Directed Donation</Label>;
        case DonorIntakeSituation.FamilyVoucher: return <Label bsStyle='success'>{vemDesc}Family Voucher Donation</Label>;
    }

    return <>??</>;
}

export default PreferredDonationType;